import React, { useState } from "react"
import PropTypes from "prop-types"

import Formats from "./formats"
import Updater from "./updater"

const Topic = props => {
  Topic.propTypes = {
    path: PropTypes.string.isRequired,
    format: PropTypes.string.isRequired,
    type: PropTypes.string
  }

  const updater = new Updater(props.path)
  const [data, setData] = useState(props)
  const Format = Formats[data.format]

  if (data.status == "processing") {
    updater.run(data => {
      setData(data)
    })
  } else {
    updater.idle()
  }

  if (Format == undefined) {
    throw `Format Error. Couldn't find the following format: ${
      props.type
    }. Following types are accepted:\n ${Object.keys(Formats).join("\n ")}`
  }

  return <Format {...data} />
}

export default Topic
